import { useQuery } from "@apollo/client";
import { useCallback, useEffect, useState } from "react";
import { Col, Modal, ModalBody, ModalFooter, ModalHeader, Row } from "reactstrap";

import { GET_GLOBAL_CATEGORIES } from "../../../../graphql/org-gql";
import { ICategory, IOrg, IGlobalCategoriesResponse } from "../../../../types/org";
import OrgTree from "../../../common/org-tree/org-tree";
import SpinnerOverlay from "../../../common/spinner/spinner";
import Button from "../../../common/button";

export default function SelectOrgModal(props: {
  isOpen: boolean,
  toggle: () => void,
  onSelect: (org?: ICategory | IOrg) => void
}) {
  const { isOpen, toggle, onSelect } = props;

  const [selectedOrg, setSelectedOrg] = useState<ICategory | IOrg | undefined>(undefined);

  const { loading, error, data } = useQuery<IGlobalCategoriesResponse>(GET_GLOBAL_CATEGORIES);

  useEffect(() => setSelectedOrg(undefined), [isOpen]);

  const handleConfirm = useCallback(() => {
    onSelect(selectedOrg);
    toggle();
  }, [selectedOrg, onSelect, toggle]);

  return (
    <Modal size="lg" isOpen={isOpen} toggle={toggle} backdrop="static">
      <ModalHeader toggle={toggle} tag={'h2'}>Select an Organization to Filter by</ModalHeader>
      <ModalBody className="org-selector-panel" scrollable='true'>
        {loading && <SpinnerOverlay />}
        {error && <div className="alert alert-danger" role="alert"><small>Error loading organizations</small></div>}
        {data && (<OrgTree roots={data.globalCategories ?? []} isGlobal={true} onSelected={setSelectedOrg} />)}
      </ModalBody>
      <ModalFooter>
        <Row className="w-200">

          <Col className="col-auto pe-0">
            <Button color="primary" onClick={handleConfirm} disabled={!(selectedOrg&&('orgName' in selectedOrg))}>Confirm</Button>
          </Col>
          <Col className="col-auto pe-0">
            <Button color="secondary" onClick={toggle}>Cancel</Button>
          </Col>
        </Row>
      </ModalFooter>
    </Modal>
  );
}
